
import React from 'react';
import { Helmet } from 'react-helmet';
import SitemapGeneratorTrigger from '@/components/admin/SitemapGeneratorTrigger';

export default function AdminToolsPage() {
  return (
    <>
      <Helmet>
        <title>Admin Tools | Grandpal</title>
      </Helmet>
      
      <div className="container mx-auto px-4 py-8">
        <h1 className="text-3xl font-bold mb-6">Admin Tools</h1>
        
        <div className="grid gap-8 md:grid-cols-1 lg:grid-cols-2">
          <SitemapGeneratorTrigger />
          
          {/* Add more admin tools here as needed */}
        </div>
      </div>
    </>
  );
}
